import { useMemo } from 'react'
import { useTheme } from '@mui/material/styles'
import { createKiotFieldSurfaceTheme } from '@/theme/kiotFieldSurfaceTheme'
import type { FieldSurface } from '@/components/common/formFields/fieldSurfaces/types'

export function useKiotFieldSurfaceTheme(surface: FieldSurface = 'form') {
  const base = useTheme()
  return useMemo(() => createKiotFieldSurfaceTheme(base, surface), [base, surface])
}

/** @deprecated — form surface only. */
export function useKiotFormTheme() {
  return useKiotFieldSurfaceTheme('form')
}
